module.exports = __webpack_public_path__ + "img/photography.be5030ca.webp";